import React, { useState } from "react"
import { Icon, Message } from "semantic-ui-react"
import { useRemoveItemFromGroup } from "../../../../../Hooks/FetchHooks/DeleteDataService/useRemoveItemFromGroup"
import BifrostButton from "../../../../BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostModal from "../../../BifrostModal/BifrostModal"
import Loader from "../../../Loader/Loader"

const RemoveFromGroupModal = ({ item, group, refreshData }) => {
	const [openModal, setOpenModal] = useState(false)
	const [mouseHover, setMouseHover] = useState(false)

	const { isLoading, isError, setIsError, removeItemFromGroup } = useRemoveItemFromGroup()

	const submitHandler = (item) => {
		removeItemFromGroup(group.id, item.id, item.listType).then(() => {
			setOpenModal(false)
			refreshData()
		})
	}

	const cancelHandler = () => {
		console.log("cancelHandler")
		setOpenModal(false)
		setIsError(false)
	}

	return (
		<BifrostModal
			title={"Remove " + item.listType.replace(item.listType[0], item.listType[0].toUpperCase()).slice(0, -1) + " from Group"}
			open={openModal}
			setOpen={setOpenModal}
			closeOnEscape={!isLoading}
			closeOnDimmerClick={!isLoading}
			trigger={
				<Icon
					name="minus"
					size="small"
					circular={true}
					onMouseEnter={() => setMouseHover(true)}
					onMouseLeave={() => setMouseHover(false)}
					style={{
						color: "darkred",
						backgroundColor: mouseHover ? "lightgrey" : null
					}}
				/>
			}
			modalPage={
				<>
					{isLoading ? (
						<Loader backgroundColor="white" inverted height="1px" minHeight="20px" />
					) : isError ? (
						<Message negative>
							<p> Something went wrong</p>
						</Message>
					) : (
						<p style={{ color: "black" }}>
							Are you sure you want to remove <b>{item.name}</b> from <b>{group && group.name}</b>?
						</p>
					)}
				</>
			}
			modalActions={
				<>
					{!isError && !isLoading && (
						<BifrostButton
							disabled={isLoading}
							style={{ display: "inline-block" }}
							onClick={(e) => {
								e.stopPropagation()
								submitHandler(item)
							}}
							color="red"
						>
							Remove
						</BifrostButton>
					)}
					<BifrostButton
						color="gray"
						style={{ display: "inline-block" }}
						onClick={(e) => {
							e.stopPropagation()
							cancelHandler()
						}}
					>
						Cancel
					</BifrostButton>
				</>
			}
		/>
	)
}

RemoveFromGroupModal.propTypes = {}

export default RemoveFromGroupModal
